import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { KendoGridHelper } from '../../kendo-grid-helper';
import { MultipleSortSettings } from '@progress/kendo-angular-grid';
import { SortDescriptor, State, CompositeFilterDescriptor, FilterDescriptor } from "@progress/kendo-data-query";
import { CrossSiteUserNotificationsColumnDef, CrossSiteUserNotificationsStateInfo } from './cross-site-user-notifications.classes';
import { Router } from '@angular/router';
//import { CrossSiteUserFavoriteFormsData } from '../../models/site-content/cross-site-user-favorite-form.model';
import { CrossSiteUserNotificationsData } from '../../models/site-content/cross-site-user-notifications.model';
import { CrossSiteUserNotificationsRemoteBindingDirective } from '../../directives/cross-site-user-notifications.directive';
import { FormInstanceService } from '../../services/form-instance.service';
import { ConfirmationDialogComponent, ConfirmationDialogModel } from '../../dialogs/confirmation/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-cross-site-user-notifications',
    //imports: [],
    templateUrl: './cross-site-user-notifications.component.html',
    styleUrl: './cross-site-user-notifications.component.scss',
    standalone: false
})
export class CrossSiteUserNotificationsComponent {
    // Properties.
    @ViewChild(CrossSiteUserNotificationsRemoteBindingDirective) public remoteBindingDirectiveRef: CrossSiteUserNotificationsRemoteBindingDirective;
    private helper = new KendoGridHelper();
    private kendoGridData: CrossSiteUserNotificationsStateInfo = new CrossSiteUserNotificationsStateInfo();

    // Configuration data.
    public columnDefs: CrossSiteUserNotificationsColumnDef[] = [
        { fieldName: 'formName', title: 'Name', width: '200' },
        { fieldName: 'siteName', title: 'Site', width: '75' },
        { fieldName: 'modifiedDate', title: 'Modified Date', width: '75' },
        { fieldName: 'modifiedBy', title: 'Modified By', width: '75' },
        { fieldName: 'workflowState', title: 'Status', width: '75' }
    ];

    // Constructor.
    public constructor(private router: Router, private dialog: MatDialog, private formInstanceService: FormInstanceService) { }

    // Life cycle methods.
    public ngOnInit(): void {
    }

    // Define property-related methods used by my HTML code.
    public SubscribedIcon(dataItem: CrossSiteUserNotificationsData): string {
        if (dataItem.isSuscribedToWorkflowChanges) {
            return "notifications_active";
        } else {
            return "notifications";
        }
    }

    public get SortSettings(): any {
        let settings: MultipleSortSettings = {
            //mode: "multiple",
            initialDirection: "asc",
            allowUnsort: true,
            showIndexes: true,
        };
        return settings;
    }

    // Getters / Setters
    public get ColumnDefs() {
        return this.columnDefs;
    }

    public get Helper(): KendoGridHelper {
        return this.helper;
    }
    // Getters for virtual scrolling
    public get PageSize(): number {
        return this.kendoGridData.gridState.take;
    }

    public get Skip(): number {
        return this.kendoGridData.gridState.skip;
    }
    public get Sort(): SortDescriptor[] {
        return this.kendoGridData.gridState.sort;
    }

    // Methods for handling control events.
    public openForm(dataItem: CrossSiteUserNotificationsData): void {
        window.open(`/site/${dataItem.siteId}/form-instance/${dataItem.formId}`, '_blank').focus();
    }

    public toggleSubscribed(dataItem: CrossSiteUserNotificationsData): void {
        // If the user is unsubscribing, give them a warning that it will be removed from the Grid
        /*
        if (dataItem.isFavorite) {
            let dialogRef = this.dialog.open(ConfirmationDialogComponent, {
                width: "400px",
                data: new ConfirmationDialogModel(
                    `Unfave`,
                    `Are you sure you want to unfave the Form "${dataItem.formName}"? <br/><br/> If you proceed it will continue to display in this grid for now, but will no longer be displayed upon reload.`
                )
            });
            dialogRef.afterClosed().subscribe(yes => {
                if (yes) {
                    this.doToggleSubscribed(dataItem);
                }
            });
        } else {
            this.doToggleSubscribed(dataItem);
        }
        */
        this.doToggleSubscribed(dataItem);
    }

    // Helper methods.
    private doToggleSubscribed(dataItem: CrossSiteUserNotificationsData) {
        //dataItem.isSuscribedToWorkflowChanges = !dataItem.isSuscribedToWorkflowChanges;
        let newIsSubscribedValue: boolean = !dataItem.isSuscribedToWorkflowChanges;
        this.formInstanceService.toggleIsSubscribedToWorkflowChanges(dataItem.formId, newIsSubscribedValue).then(fi => {
            // Now that the server has responded, we can update the form's icon.
            dataItem.isSuscribedToWorkflowChanges = newIsSubscribedValue;
        });
    }
}
